export default __webpack_public_path__ + "static/media/cp_geo_bl.2b7587ab.svg";